import React, { useState } from "react";
import Icon from "components/AppIcon";

const topAccounts = [
  { rank: 1, name: "SM Supermarket - Makati", type: "Key Account", region: "NCR", salesperson: "Juan dela Cruz", mtdSales: 1240000, target: 1200000, growth: 12.4, status: "active" },
  { rank: 2, name: "Puregold - Quezon City", type: "Key Account", region: "NCR", salesperson: "Maria Santos", mtdSales: 980000, target: 950000, growth: 8.7, status: "active" },
  { rank: 3, name: "Robinsons Supermarket - Cebu", type: "Key Account", region: "Visayas", salesperson: "Carlo Reyes", mtdSales: 875000, target: 900000, growth: -2.8, status: "active" },
  { rank: 4, name: "Metro Gaisano - Davao", type: "Distributor", region: "Mindanao", salesperson: "Ana Gomez", mtdSales: 760000, target: 720000, growth: 15.2, status: "active" },
  { rank: 5, name: "Savemore - Pampanga", type: "Retail Chain", region: "Luzon", salesperson: "Ben Torres", mtdSales: 680000, target: 700000, growth: -3.1, status: "at-risk" },
  { rank: 6, name: "Landers Superstore - BGC", type: "Key Account", region: "NCR", salesperson: "Lisa Tan", mtdSales: 620000, target: 600000, growth: 6.8, status: "active" },
  { rank: 7, name: "Waltermart - Bulacan", type: "Retail Chain", region: "Luzon", salesperson: "Mark Lim", mtdSales: 540000, target: 580000, growth: -7.2, status: "at-risk" },
];

const formatPHP = (v) => `₱${(v / 1000)?.toFixed(0)}K`;

export default function TopAccountsTable() {
  const [sortField, setSortField] = useState("mtdSales");
  const [sortDir, setSortDir] = useState("desc");

  const handleSort = (field) => {
    if (sortField === field) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else { setSortField(field); setSortDir("desc"); }
  };

  const sorted = [...topAccounts]?.sort((a, b) => {
    const mul = sortDir === "asc" ? 1 : -1;
    return (a?.[sortField] > b?.[sortField] ? 1 : -1) * mul;
  });

  const SortIcon = ({ field }) => (
    <Icon
      name={sortField === field ? (sortDir === "asc" ? "ChevronUp" : "ChevronDown") : "ChevronsUpDown"}
      size={13}
      color="currentColor"
      strokeWidth={2}
    />
  );

  return (
    <div className="card p-4 md:p-5 lg:p-6 table-panel-depth">
      <div className="flex items-center justify-between mb-3 md:mb-4 flex-wrap gap-2">
        <div>
          <h3 className="font-heading text-base md:text-lg lg:text-xl font-semibold" style={{ color: '#0F172A', letterSpacing: '0.01em' }}>Top Accounts</h3>
          <p className="font-caption text-xs sm:text-sm mt-0.5" style={{ color: '#475569' }}>MTD performance — March 2026</p>
        </div>
        <span className="font-caption text-xs px-2.5 py-1 rounded-full font-medium" style={{ background: 'rgba(220, 38, 38, 0.12)', color: '#DC2626', border: '1px solid rgba(220, 38, 38, 0.25)' }}>
          {topAccounts?.length} accounts
        </span>
      </div>

      {/* Desktop & Tablet: scrollable table */}
      <div className="hidden sm:block overflow-x-auto custom-scrollbar -mx-4 md:mx-0">
        <table className="w-full min-w-[580px]">
          <thead>
            <tr className="border-b border-border">
              {[
                { label: "#", field: "rank", w: "w-8" },
                { label: "Account", field: "name", w: "w-auto" },
                { label: "Region", field: "region", w: "w-20" },
                { label: "Salesperson", field: "salesperson", w: "w-28" },
                { label: "MTD Sales", field: "mtdSales", w: "w-24" },
                { label: "Growth", field: "growth", w: "w-20" },
                { label: "Status", field: "status", w: "w-20" },
              ]?.map((col) => (
                <th
                  key={col?.field}
                  className={`${col?.field === 'name' ? 'sticky left-0 bg-card z-10' : ''} ${col?.w} pb-2 px-2 md:px-3 text-left font-caption text-xs font-semibold uppercase tracking-wider cursor-pointer transition-colors`}
                  style={{ color: '#374151' }}
                  onClick={() => handleSort(col?.field)}
                >
                  <div className="flex items-center gap-1">
                    {col?.label}
                    <SortIcon field={col?.field} />
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted?.map((acc, idx) => (
              <tr key={acc?.rank} className={`border-b border-border last:border-0 hover:bg-muted transition-colors`}>
                <td className="py-2 md:py-3 px-2 md:px-3">
                  <span className="font-data text-sm" style={{ color: '#475569' }}>{acc?.rank}</span>
                </td>
                <td className="py-2 md:py-3 px-2 md:px-3 sticky left-0 bg-card z-10">
                  <div>
                    <p className="font-caption text-xs md:text-sm font-semibold line-clamp-1" style={{ color: '#1E293B' }}>{acc?.name}</p>
                    <span className="font-caption text-xs" style={{ color: '#475569' }}>{acc?.type}</span>
                  </div>
                </td>
                <td className="py-2 md:py-3 px-2 md:px-3">
                  <span className="font-caption text-xs md:text-sm" style={{ color: '#1E293B' }}>{acc?.region}</span>
                </td>
                <td className="py-2 md:py-3 px-2 md:px-3">
                  <span className="font-caption text-xs md:text-sm line-clamp-1" style={{ color: '#1E293B' }}>{acc?.salesperson}</span>
                </td>
                <td className="py-2 md:py-3 px-2 md:px-3">
                  <span className="font-data text-xs md:text-sm font-semibold" style={{ color: '#0F172A' }}>{formatPHP(acc?.mtdSales)}</span>
                </td>
                <td className="py-2 md:py-3 px-2 md:px-3">
                  <div className={`flex items-center gap-1 font-data text-xs md:text-sm font-semibold ${acc?.growth >= 0 ? "text-emerald-600" : "text-red-600"}`}>
                    <Icon name={acc?.growth >= 0 ? "TrendingUp" : "TrendingDown"} size={12} color="currentColor" strokeWidth={2.5} />
                    {acc?.growth >= 0 ? "+" : ""}{acc?.growth}%
                  </div>
                </td>
                <td className="py-2 md:py-3 px-2 md:px-3">
                  <span className={`font-caption text-xs px-2 py-0.5 rounded-full font-medium`} style={acc?.status === "active" ? { background: 'rgba(34, 197, 94, 0.12)', color: '#059669', border: '1px solid rgba(34, 197, 94, 0.25)' } : { background: 'rgba(212, 175, 55, 0.12)', color: '#D97706', border: '1px solid rgba(212, 175, 55, 0.25)' }}>
                    {acc?.status === "active" ? "Active" : "At Risk"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile: card-stacked layout */}
      <div className="sm:hidden space-y-2">
        {sorted?.map((acc) => (
          <div key={acc?.rank} className="border border-border rounded-lg p-3 bg-card">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-1.5 mb-0.5">
                  <span className="font-data text-xs font-bold" style={{ color: '#475569' }}>#{acc?.rank}</span>
                  <p className="font-caption text-sm font-semibold truncate" style={{ color: '#1E293B' }}>{acc?.name}</p>
                </div>
                <span className="font-caption text-xs" style={{ color: '#475569' }}>{acc?.type}</span>
              </div>
              <span className={`font-caption text-xs px-2 py-0.5 rounded-full font-medium flex-shrink-0`} style={acc?.status === "active" ? { background: 'rgba(34, 197, 94, 0.12)', color: '#059669', border: '1px solid rgba(34, 197, 94, 0.25)' } : { background: 'rgba(212, 175, 55, 0.12)', color: '#D97706', border: '1px solid rgba(212, 175, 55, 0.25)' }}>
                {acc?.status === "active" ? "Active" : "At Risk"}
              </span>
            </div>
            <div className="grid grid-cols-2 gap-x-3 gap-y-1.5">
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Region</p>
                <p className="font-caption text-xs font-medium" style={{ color: '#1E293B' }}>{acc?.region}</p>
              </div>
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Salesperson</p>
                <p className="font-caption text-xs font-medium truncate" style={{ color: '#1E293B' }}>{acc?.salesperson}</p>
              </div>
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>MTD Sales</p>
                <p className="font-data text-sm font-bold" style={{ color: '#0F172A' }}>{formatPHP(acc?.mtdSales)}</p>
              </div>
              <div>
                <p className="font-caption" style={{ fontSize: '10px', color: '#94A3B8' }}>Growth</p>
                <div className={`flex items-center gap-1 font-data text-sm font-semibold ${acc?.growth >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                  <Icon name={acc?.growth >= 0 ? 'TrendingUp' : 'TrendingDown'} size={11} color="currentColor" strokeWidth={2.5} />
                  {acc?.growth >= 0 ? '+' : ''}{acc?.growth}%
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}